import { cn } from '@sparkai/utils'

export function Dot({ className, size }: { className?: string; size: 'small' | 'large' }) {
  return (
    <div
      className={cn(
        'absolute -right-[1px] -bottom-[2px] rounded-full',
        {
          'h-2 w-2': size === 'small',
          'h-3 w-3': size === 'large',
        },
        className
      )}
    />
  )
}
